import React from 'react';

import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import {
  DropdownMenuPortal,
  DropdownMenuSub,
  DropdownMenuSubContent,
  DropdownMenuSubTrigger,
} from '@/components/ui/dropdown-menu';
import { filterShape } from '../../../types';
import FilterSubMenu from './FilterSubMenu';

const FilterMenu = ({ activeFilters, clearFilters, filters }) => (
  <>
    {filters.map(
      ({
        emptyMessage,
        icon,
        label,
        listComponent: FilterList,
        searchPlaceholder,
        type,
      }) => (
        <DropdownMenuSub key={type}>
          <DropdownMenuSubTrigger className="gap-2">
            <FontAwesomeIcon className="text-muted-foreground" fixedWidth icon={icon} />
            {label}
          </DropdownMenuSubTrigger>

          <DropdownMenuPortal>
            <DropdownMenuSubContent className="p-0 w-[200px]">
              <FilterSubMenu
                activeFilters={activeFilters[type]}
                emptyMessage={emptyMessage}
                onClear={() => clearFilters(type)}
                searchPlaceholder={searchPlaceholder}
              >
                <FilterList />
              </FilterSubMenu>
            </DropdownMenuSubContent>
          </DropdownMenuPortal>
        </DropdownMenuSub>
      )
    )}
  </>
);

FilterMenu.propTypes = {
  activeFilters: PropTypes.objectOf(PropTypes.arrayOf(PropTypes.string)).isRequired,
  clearFilters: PropTypes.func.isRequired,
  filters: PropTypes.arrayOf(filterShape).isRequired,
};

export default FilterMenu;
